<div class="check-current-user-container">
    <div *ngIf="email">
        <h4>{{"ACCOUNT.MY_ACCOUNT" | translate}}</h4>
        <div class="check-current-user-inner">
            <div class="row align-items-center">
                <div class="col-md-8 col-12 text-md-left text-center mb-md-0 mb-10">
                    <span>{{"ACCOUNT.LOGGED_MESSAGE" | translate}} {{email}}</span>
                </div>
                <div class="col-md-4 col-12 text-md-right text-center">
                    <a (click)="onLogout()" href="https://agribusinessjob.ro:9595/agri/logout" class="green-button"><i class="icofont-exit"></i>{{"ACCOUNT.LOG_OUT" | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
